import React from 'react';
import { buildImagePath } from '../../Content/User/UserDisplay/UserImage/UserImage';
import {
    COMPANY_BADGE_IMAGE_SOURCES,
    COMPANY_BADGE_TYPES_PROP,
} from '../../Includes/CompanyProps';
import './Badge.scss';

export default class Badge extends React.PureComponent {
    static propTypes = {
        /**
         * badge type
         */
        type: COMPANY_BADGE_TYPES_PROP,
    };

    static defaultProps = {};

    render() {
        const injectedTransforms = {
            small: 'c_scale,w_107,h_99',
        };
        const src = buildImagePath(
            COMPANY_BADGE_IMAGE_SOURCES[this.props.type],
            'small',
            injectedTransforms
        );

        return (
            <div className={'component-Elements-Badge'}>
                <img src={src} />
            </div>
        );
    }
}
